<template>

  <div>

    <div class="Modal__header">
      <h3>Choisir une couleur</h3>
    </div>

    <div class="Modal__body"  >
      <color-picker :colors.sync="hexColor" ></color-picker>
    </div>

    <div class="Modal__footer">
      <button class="Modal__buton-ok" @click="cancel()">
        Ok
      </button>
    </div>

  </div>

</template>

<script>
  import { Swatches } from 'vue-color'

  export default{
    props: ['color'],
    data () {
      return {
        hexColor: {
          hex: this.color
        }
      }
    },
    components: {
      'color-picker': Swatches
    },
    methods: {
      cancel () {
        this.color = this.hexColor.hex
        this.$dispatch('closeModal')
      }
    }
  }
</script>

<style lang='scss'>
</style>



// WEBPACK FOOTER //
// ColorPicker.vue?352ef805